import utils from '../utils';
import extendUserModel from './extendUserModel';

export function extendTimesheetEntry(_model) {
  const model = { ..._model };
  model.timestampLocal = new Date(model.timestamp);
  model.timestamp = utils.getRealDate(model.timestamp);

  model.user = extendUserModel(model.user);
  return model;
}

export function extendTimesheetProjection(_model) {
  const model = { ..._model };
  model.clockInLocal = new Date(model.clockIn);
  model.clockIn = utils.getRealDate(model.clockIn);

  model.lastActionLocal = new Date(model.lastAction);
  model.lastAction = utils.getRealDate(model.lastAction);

  if (model.clockOut) {
    model.clockOutLocal = new Date(model.clockOut);
    model.clockOut = utils.getRealDate(model.clockOut);
  }

  model.user = extendUserModel(model.user);
  return model;
}
